module.exports = __webpack_public_path__ + "img/mesa.8f61af73.jpg";